var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4,2.7c-0.5-0.6-1.4-0.8-2.2-0.6L3.7,6.6c-0.9,0.3-1.5,1-1.6,1.9c-0.2,0.9,0.2,1.7,1,2.2l5.4,3.5l6.7-6.7 c0.4-0.4,1-0.4,1.4,0c0.4,0.4,0.4,1,0,1.4l-6.7,6.7l3.3,5.3c0.4,0.7,1.1,1.1,1.9,1.1c0.1,0,0.2,0,0.4,0c0.9-0.1,1.6-0.7,1.9-1.6 L22,5C22.2,4.2,22,3.3,21.4,2.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendFill);
export default __webpack_public_path__ + "static/media/send-fill.4bfb9e7aa66ff909e73c1a7805764dc4.svg";
export { ForwardRef as ReactComponent };